import FieldsConstants from 'src/app/common/fields.constants';
import FieldAllowedAttributeTypes from 'src/app/forms/fields/field-allowed-attribute-types.values';
import FieldAllowedValueClasses from 'src/app/forms/fields/field-allowed-value-classes.values';
import { FormTypes } from 'src/app/forms/forms.enum';
import { Attribute } from 'src/app/interfaces/form-and-field.interface';

export const richEditorAttr: Attribute = {
  name: 'text',
  value_class_front: FieldAllowedValueClasses.RICH_EDITOR,
  min_length: 1,
  max_length: FieldsConstants.MAX_RICH_TEXT_EDITOR_SYMBOLS_COUNT,
  type_attribute: FieldAllowedAttributeTypes.RICH_EDITOR,
  required: true,
  read_only: false,
  label: 'FORM_CONSTRUCTOR_POST_TEXT_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_POST_TEXT_PLACEHOLDER',
  security: false,
  scheme_name: FormTypes.POST,
};

export const communityIdAttr: Attribute = {
  name: 'community_id',
  value_class_front: FieldAllowedValueClasses.COMMUNITIES_SEARCH_SELECT,
  min_length: 1,
  max_length: 50,
  type_attribute: FieldAllowedAttributeTypes.SEARCH_SELECT,
  required: true,
  read_only: false,
  counter_hide: true,
  label: 'FORM_CONSTRUCTOR_POST_TO_COMMUNITY_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_POST_TO_COMMUNITY_PLACEHOLDER',
  security: false,
  scheme_name: FormTypes.POST,
  enabled_if: { name: 'project_id', value: '' },
};

export const projectIdMetadata: Attribute = {
  name: 'project_id',
  value_class_front: FieldAllowedValueClasses.PROJECTS_SEARCH_SELECT,
  min_length: 1,
  max_length: 50,
  type_attribute: FieldAllowedAttributeTypes.SEARCH_SELECT,
  required: true,
  read_only: true,
  label: 'FORM_CONSTRUCTOR_POST_TO_PROJECT_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_POST_TO_PROJECT_PLACEHOLDER',
  security: false,
  scheme_name: FormTypes.POST,
  enabled_if: { name: 'community_id', value: '' },
};

export const postMetadata: Attribute[] = [
  {
    name: 'title',
    value_class_front: FieldAllowedValueClasses.CHARACTERS,
    min_length: 1,
    max_length: 100,
    type_attribute: FieldAllowedAttributeTypes.TEXT,
    required: true,
    read_only: false,
    label: 'FORM_CONSTRUCTOR_POST_TITLE_LABEL',
    placeholder: 'FORM_CONSTRUCTOR_POST_TITLE_PLACEHOLDER',
    security: false,
    scheme_name: FormTypes.POST,
  },
  richEditorAttr,
  communityIdAttr,
  projectIdMetadata,
];
